import { AdvisorLayerMode } from '../enums/advisorLayerMode'
import { getModeFromPath } from './advisorLayerModeFromPath'
import { getModeFromSearch } from './advisorLayerModeSearchParam'

export const getModeFromUrl = (pathname: string, search: string): AdvisorLayerMode | undefined =>
  getModeFromSearch(search) ?? getModeFromPath(pathname)
